export default "__VITE_ASSET__neQAWjXa__"